import { render, staticRenderFns } from "./loginnew.vue?vue&type=template&id=6177448c&scoped=true"
import script from "./loginnew.vue?vue&type=script&lang=js"
export * from "./loginnew.vue?vue&type=script&lang=js"
import style0 from "./loginnew.vue?vue&type=style&index=0&id=6177448c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6177448c",
  null
  
)

export default component.exports